// The current-sensor screen — DeviceID 82 (single-phase) and 16 (three-phase).
//
// Since 2026-10-19 this is the ENERGY PAGE, shared with the desktop:
// ui/shared/energy/EnergyPanel.jsx (tariff formula, live, bill so far and
// projected, findings, daily units, load profile, waste, phase balance,
// voltage, power factor, peak, data quality, one day in detail, history and
// bill check). The phone adds only its header bar.
//
// It replaced the Flutter-parity screen (power graph · current graph · From/To
// · Pick a Date). "One day in detail" on the panel is that graph, with voltage.

import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DeviceAppBar from './components/DeviceAppBar';
import EnergyPanel from '../../../shared/energy/EnergyPanel';

export default function PhaseScreen({ device, threePhase = false }) {
  const theme = useTheme();
  return (
    <Box sx={{ height: '100%', bgcolor: theme.sli.back, display: 'flex', flexDirection: 'column' }}>
      <DeviceAppBar device={device} subtitle={device?.LocationName ?? ''} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <EnergyPanel device={device} phaseCount={threePhase ? 3 : 1} />
      </Box>
    </Box>
  );
}
